import { DateTime } from 'luxon'

/**
 * Default filter: last 30 calendar days (inclusive), UTC date boundaries.
 * @returns {{ fromDate: string, toDate: string }}
 */
export function defaultDateRangeUtc () {
  const to = DateTime.utc().startOf('day')
  const from = to.minus({ days: 30 })
  return {
    fromDate: from.toISODate(),
    toDate: to.toISODate()
  }
}

/**
 * Mirrors Campaigns GetPushDeliveryMetricsRequest: `from`/`to` are date-only (YYYY-MM-DD);
 * max range uses calendar months (from + 12 months < to).
 *
 * @param {string} fromDate YYYY-MM-DD
 * @param {string} toDate YYYY-MM-DD
 * @returns {{ valid: boolean, code?: string }}
 */
export function validateDeliveryMetricsDateRange (fromDate, toDate) {
  if (!fromDate || !toDate) {
    return { valid: false, code: 'missing' }
  }
  const from = DateTime.fromISO(fromDate, { zone: 'utc' }).startOf('day')
  const to = DateTime.fromISO(toDate, { zone: 'utc' }).startOf('day')
  if (!from.isValid || !to.isValid) {
    return { valid: false, code: 'invalid' }
  }
  if (to < from) {
    return { valid: false, code: 'to_before_from' }
  }
  if (from.plus({ months: 12 }) < to) {
    return { valid: false, code: 'range_too_long' }
  }
  return { valid: true }
}
